/**
 * GeoJSON helpers for the geospatial configurator — pure, framework-free, so
 * they are unit-testable without Leaflet or a DOM.
 *
 * Convention: GeoJSON coordinates are [lon, lat]; Leaflet wants [lat, lng].
 */

/** Parses a GeoJSON string, returning null instead of throwing on bad input. */
export function safeParseGeoJson(s) {
  try {
    return JSON.parse(s);
  } catch {
    return null;
  }
}

/**
 * Converts a GeoJSON geometry (lon,lat) to Leaflet latlngs (lat,lng).
 * @returns {{kind: string, latlngs: *}|null}
 */
export function toLatLngs(geometry) {
  if (!geometry) return null;
  const c = geometry.coordinates;
  if (geometry.type === 'Point') {
    return { kind: 'Point', latlngs: [c[1], c[0]] };
  }
  if (geometry.type === 'LineString') {
    return { kind: 'LineString', latlngs: c.map((p) => [p[1], p[0]]) };
  }
  if (geometry.type === 'Polygon') {
    return { kind: 'Polygon', latlngs: c[0].map((p) => [p[1], p[0]]) };
  }
  return null;
}

/**
 * Builds a GeoJSON geometry from points drawn on the map ([lat,lng] pairs).
 *
 * @param kind   'Point', 'LineString' or 'Polygon'
 * @param points array of [lat, lng]
 * @returns the GeoJSON geometry, or null if there are too few points
 */
export function buildGeometry(kind, points) {
  const lonlat = (points || []).map(([lat, lng]) => [lng, lat]);
  if (kind === 'Point') {
    return lonlat.length >= 1 ? { type: 'Point', coordinates: lonlat[0] } : null;
  }
  if (kind === 'LineString') {
    return lonlat.length >= 2 ? { type: 'LineString', coordinates: lonlat } : null;
  }
  if (kind === 'Polygon') {
    if (lonlat.length < 3) return null;
    return { type: 'Polygon', coordinates: [[...lonlat, lonlat[0]]] }; // ring auto-closed
  }
  return null;
}
